import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { Locale } from "@/lib/i18n";
import { toLocalizedPath } from "@/lib/i18n";
import Icon from "./Icon";
export default function HomeExplorerShortcuts(t0) {
  const $ = _c(19);
  const {
    locale
  } = t0;
  let t1;
  if ($[0] !== locale) {
    t1 = toLocalizedPath("/", locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const home = t1;
  const t2 = locale === "ko" ? "\uC0C1\uD669\uBCC4 \uD14C\uC2A4\uD2B8 \uCC3E\uAE30" : "Find quizzes for your situation";
  const t3 = `${home}?cat=social#home-explore`;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon name="users" size={16} />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = locale === "ko" ? "\uCE5C\uAD6C \xB7 \uAD00\uACC4" : "Friends \xB7 social";
  let t6;
  if ($[3] !== t3 || $[4] !== t5) {
    t6 = <Link href={t3} prefetch={false} className="inline-flex min-h-11 items-center gap-2 rounded-full bg-sky-50 px-4 text-sm text-sky-900 ring-1 ring-sky-200">{t4}{t5}</Link>;
    $[3] = t3;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `${home}?cat=love#home-explore`;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Icon name="heart" size={16} />;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const t9 = locale === "ko" ? "\uCEE4\uD50C \xB7 \uC5F0\uC560" : "Couples \xB7 dating";
  let t10;
  if ($[7] !== t7 || $[8] !== t9) {
    t10 = <Link href={t7} prefetch={false} className="inline-flex min-h-11 items-center gap-2 rounded-full bg-rose-50 px-4 text-sm text-rose-900 ring-1 ring-rose-200">{t8}{t9}</Link>;
    $[7] = t7;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = `${home}?duration=1#home-explore`;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Icon name="clock" size={16} />;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  const t13 = locale === "ko" ? "\uC57D 1\uBD84" : "About 1 min";
  let t14;
  if ($[11] !== t11 || $[12] !== t13) {
    t14 = <Link href={t11} prefetch={false} className="inline-flex min-h-11 items-center gap-2 rounded-full bg-amber-50 px-4 text-sm text-amber-900 ring-1 ring-amber-200">{t12}{t13}</Link>;
    $[11] = t11;
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t10 || $[15] !== t14 || $[16] !== t2 || $[17] !== t6) {
    t15 = <nav aria-label={t2} className="flex flex-wrap gap-2">{t6}{t10}{t14}</nav>;
    $[14] = t10;
    $[15] = t14;
    $[16] = t2;
    $[17] = t6;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  return t15;
}